import { Maybe } from '../../../__generated__/globalTypes'

import { FeatureFragment, isFeatureFragment } from './FeatureFragment'

import { PlanFeatureIcon, isPlanFeatureIcon } from './PlanFeatureIcon'

import planFeatureFragmentRawString from '../PlanFeatureFragment.graphql'

export const planFeatureFragmentString = planFeatureFragmentRawString

export type PlanFeatureFragment = {
  feature: FeatureFragment
  value: Maybe<string>
  included: boolean
  featured: boolean
  icons: PlanFeatureIcon[]
}

export const isPlanFeatureFragment = (
  fragment: any,
): fragment is PlanFeatureFragment =>
  fragment &&
  (isFeatureFragment(fragment.feature) as boolean) &&
  (fragment.value === null || typeof fragment.value === 'string') &&
  typeof fragment.included === 'boolean' &&
  typeof fragment.featured === 'boolean' &&
  Array.isArray(fragment.icons) &&
  fragment.icons
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) => accum && (isPlanFeatureIcon(next) as boolean),
      true,
    )
